import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { openDialog } from '../../../base/dialog/actions';
import { translate } from '../../../base/i18n/functions';
import { IconGear } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import CaptionStyleDialog from './CaptionStyleDialog';
/**
 * Opens caption style settings without leaving the conference — size, hold
 * time, expressive mode, and motion live in one popover.
 */
class CaptionStyleButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'captionSettings.open';
        this.icon = IconGear;
        this.label = 'captionSettings.title';
        this.tooltip = 'captionSettings.title';
    }
    /**
     * Handles clicking / pressing the button.
     *
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        sendAnalytics(createToolbarEvent('caption.style.open'));
        dispatch(openDialog(CaptionStyleDialog));
    }
}
export default translate(connect()(CaptionStyleButton));
